import { useMemo } from 'react'
import type {
  CardTextualItemData,
  CardTextualProps,
} from 'src/types/cardTextual2'
import isSafeLink from 'src/utils/isSafeLink'

import CardTextualItem from './CardTextualItem'

const MAX_CARDS = 3

const isCardValid = (item?: CardTextualItemData) => {
  return Boolean(
    item?.flag?.trim() &&
      item?.title?.trim() &&
      item?.text?.trim() &&
      item?.buttonLabel?.trim() &&
      isSafeLink(item?.buttonLink)
  )
}

const gridColsByCount: Record<number, string> = {
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
}

export default function CardTextual20({
  enableSession = true,
  sectionTitle,
  items = [],
}: CardTextualProps) {
  const parsedItems = useMemo(() => {
    return items.filter(isCardValid).slice(0, MAX_CARDS)
  }, [items])

  if (!enableSession || parsedItems.length === 0) {
    return null
  }

  const desktopGridCols =
    gridColsByCount[parsedItems.length] ?? gridColsByCount[3]

  const isSingleCard = parsedItems.length === 1
  const mobileGridClasses = isSingleCard
    ? 'grid-cols-1'
    : 'grid-flow-col auto-cols-[256px] overflow-x-auto pb-2 snap-x snap-mandatory'

  const containerPaddingMobile = isSingleCard ? 'px-3' : 'pl-3'

  return (
    <section
      data-testid="card-textual-2-0"
      aria-label="Cards editoriais"
      className="w-full bg-white"
    >
      <div
        className={`mx-auto w-full max-w-[1440px] pb-[29px] pt-[39px] ${containerPaddingMobile} md:pt-0 md:pb-[26px] md:pl-0 md:px-0`}
      >
        {sectionTitle?.trim() && (
          <h2 className="mb-7 text-[18px] font-extrabold uppercase leading-normal tracking-[1.84px] text-restructure-neutral-23 md:mb-[26px]">
            {sectionTitle}
          </h2>
        )}

        <div
          data-testid="card-textual-grid"
          className={`grid gap-4 ${mobileGridClasses} md:grid-flow-row md:auto-cols-auto ${desktopGridCols} md:gap-5 md:overflow-visible md:pb-0`}
        >
          {parsedItems.map((item, index) => (
            <CardTextualItem
              key={`${item.title}-${index}`}
              item={item}
              fullWidthMobile={isSingleCard}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
